import React from 'react';
import { Spinner } from '@fluentui/react';
import { useTranslation } from 'react-i18next';
import '../css/controll/noDataFound.scss'
type LoadingProps = {
    isShow: boolean,
    label?: string
};

export const Loading = ({ isShow, label }: LoadingProps) => {
    const { t } = useTranslation();
    return (
        <>
            {(isShow) && (
                <div className="loading-full">
                    <Spinner label={!!label ? label : "Data is loading ... Please wait"} ariaLive="assertive" labelPosition="right" />
                </div>
            )}
        </>
    );
};

